import { defineLearningWorkspace } from '@frontend/pages/learning-workspace/siteLearningWorkspace';
import manifest from './workspace.json';
import chp6 from './chp6.md';
import chp8 from './chp8.md';
import chp9 from './chp9.md';
import chp6Guide from './chp6-guide.md';
import chp8Guide from './chp8-guide.md';
import chp9Guide from './chp9-guide.md';
import chp6Preamble from './chp6-preamble.md';
import chp8Preamble from './chp8-preamble.md';
import chp9Preamble from './chp9-preamble.md';

export const learningWorkspace = defineLearningWorkspace(manifest, {
  chp6,
  chp8,
  chp9,
}, {
  chp6: chp6Guide,
  chp8: chp8Guide,
  chp9: chp9Guide,
}, {
  chp6: chp6Preamble,
  chp8: chp8Preamble,
  chp9: chp9Preamble,
});
